import { render, staticRenderFns } from "./editEvaluate.vue?vue&type=template&id=2b8bcd82&scoped=true&"
import script from "./editEvaluate.vue?vue&type=script&lang=js&"
export * from "./editEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./editEvaluate.vue?vue&type=style&index=0&id=2b8bcd82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8bcd82",
  null
  
)

export default component.exports